<div class="flex flex-column md:flex-row justify-content-between align-items-center mb-4"
     *ngIf="prj!=null&&rendertitle">
    <div class="flex flex-column text-center md:text-left">
        <span *ngIf="!hideTitle" class="text-700 text-2xl mb-2 font-bold">{{ prj.nombre }}</span>
        <span *ngIf="!hideDescription" class="text-700 text-lg">{{ prj.descripcion }}</span>
    </div>
</div>

<div class="formgrid grid" *ngIf="prj!=null">
    <div class="col-12 md:col-12">
        <p-accordion>
            <p-accordionTab *ngIf="!is_ProyectoRegistroProfesional" header="Generales" [selected]="true" class="line-height-3 m-0">
                <div class="formgrid grid">
                    <div [class]="prj.sector == null ? 'field col-12 md:col-4' : 'field col-12 md:col-3'">
                        <label class="text-900 font-semibold">Solicitud #</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.numeroExpediente }}"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3" *ngIf="prj.sector!=null">
                        <label class="text-900 font-semibold">Sector</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.sector }}"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-6" *ngIf="prj.institucion!=null">
                        <label class="text-900 font-semibold">Institución</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.institucion }}"
                               [pTooltip]="prj.institucion!"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                </div>
                <div class="formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label class="text-900 font-semibold">Naturaleza</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.naturaleza }}"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-4">
                        <label class="text-900 font-semibold">Entorno</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.entorno }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-4">
                        <label class="text-900 font-semibold">Tipo uso suelo</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.tipoUsoSuelo }}"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-4">
                        <label class="text-900 font-semibold">Categoria</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.categoria?(prj.categoria):'N/A' }}"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-4">
                        <div class="flex align-items-center">
                            <label class="text-900 font-semibold">Titular</label>
                            <p-button
                                *ngIf="mostrarCambiarTitularBoton()"
                                icon="pi pi-user-edit"
                                styleClass="p-button-info ml-4 mb-1 no-padding-button"
                                (onClick)="onAbrirEditarTitularDialog()"
                                [disabled]="proyectoPagado"
                                pTooltip="Editar Titular" 
                                tooltipPosition="right"
                            ></p-button>
                        </div>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.titular.nombreCompleto?prj.titular.nombreCompleto:'N/A' }}"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-4">
                        <label class="text-900 font-semibold">Monto de inversión</label>
                        <input type="text"
                               disabled="disabled"
                               [value]="parseToFormatNumber(prj.montoInversion!)"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-4">
                        <label class="text-900 font-semibold">Tiene Proyecto Definido</label>
                        <input type="text"
                               disabled="disabled"
                               [value]="parseTieneProyectoDefinido(prj.tieneProyectoDefinido!)"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                </div>
            </p-accordionTab>
            <p-accordionTab *ngIf="!is_ProyectoRegistroProfesional" header="Información del Inmueble" class="line-height-3 m-0">
                <div class="formgrid grid">
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Matricula</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.matricula }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Clave catastral</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.claveCatastral }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Latitud</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.latitud }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Longitud</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.longitud }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                </div>
                <div class="formgrid grid">
                    <div class="field col-12 md:col-9">
                        <label class="text-900 font-semibold">Dirección</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.complemento==null?'N/A':prj.ubicacionItem?.complemento }}"
                               class="surface-100 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Colonia/Cantón</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.complemento2==null?'N/A':prj.ubicacionItem?.complemento2 }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Departamento</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.departamento==null?'N/A':prj.ubicacionItem?.departamento }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Distrito</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.distrito==null?'N/A':prj.ubicacionItem?.distrito }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Municipio</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.ubicacionItem?.municipio==null?'N/A':prj.ubicacionItem?.municipio }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Área de inmueble en m²</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.areas ? prj.areas[0]?.area : 0 }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                </div>
                <div class="formgrid grid">
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Cobertura Vegetal</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.cobertura }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label class="text-900 font-semibold">Relieve</label>
                        <input type="text"
                               disabled="disabled"
                               value="{{ prj.relieve }}"
                               class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    </div>
                </div>
                <div class="formgrid grid">
                    <div class="field col-6 md:col-6">
                        <label class="text-900 font-semibold">({{ prj.areas?.length == null ? 0 : prj.areas?.length! }})
                            Areas</label>
                        <div class="field">
                            <p-table [value]="prj.areas!"
                                     [scrollable]="true" scrollHeight="150px"
                                     styleClass="p-datatable-striped p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Tipo de area</th>
                                        <th>Area <b> m²</b></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-ar>
                                    <tr>
                                        <td>{{ ar.tipoArea }}</td>
                                        <td>{{ ar.area }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div class="field col-6 md:col-6">
                        <label
                            class="text-900 font-semibold">({{ prj.elementoTerreno?.length == null ? 0 : prj.elementoTerreno?.length! }}
                            ) Elementos del
                            terreno</label>
                        <div class="field">
                            <p-table [value]="prj.elementoTerreno!"
                                     [scrollable]="true" scrollHeight="150px"
                                     styleClass="p-datatable-striped p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Tipo de elemento</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-elemento>
                                    <tr>
                                        <td>{{ elemento.tipoElemento }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div class="field col-6 md:col-6" *ngIf="prj.detalleConstruccionItem !== null">
                        <app-detalle-construccion-item [prj]="prj!"></app-detalle-construccion-item>
                    </div>
                    <div *ngIf="prj.lotesItem !== null" class="field col-6 md:col-6">
                        <label
                            class="text-900 font-semibold">({{ prj.lotesItem?.length == null ? 0 : prj.lotesItem?.length }}
                            ) Lotes</label>
                        <div class="field">
                            <p-table [value]="prj.lotesItem!"
                                     [scrollable]="true" scrollHeight="150px"
                                     styleClass="p-datatable-striped p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Descripción</th>
                                        <th>Cantidad</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-lotes>
                                    <tr>
                                        <td>{{ lotes.descripcion }}</td>
                                        <td>{{ lotes.cantidad }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </p-accordionTab>
            <p-accordionTab *ngIf="!is_ProyectoRegistroProfesional" header="Tenencia del Inmueble"
                            class="line-height-3 m-0">
                <div class="formgrid">
                    <p-table [value]="prj.tenencia!"
                             [scrollable]="true" scrollHeight="150px"
                             styleClass="p-datatable-striped p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Tipo de tenencia</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-ten>
                            <tr>
                                <td>{{ ten.tipoTenencia }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>

<app-editar-titular 
    [visible]="mostrarEditarTitularDialog()"
    (onClose)="onCerrarEditarTitularDialog()"
    [titulares]="titulares"
    [titularPreSeleccionado]="uniqueIdTitularActual"
    (onConfirmSubmit)="onConfirmEditarTitularDialog($event)"
>
</app-editar-titular>